
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.637 8.951h3.965c.178.055.356.11.554.15l1.264.301c1.415.342 2.01.807 2.01 1.627 0 .985-1.005 1.689-2.433 1.689-1.265 0-2.208-.568-2.564-1.538-.123-.294-.273-.424-.56-.424-.363 0-.588.225-.588.58 0 .124.013.254.048.384.362 1.292 1.79 2.098 3.67 2.098 2.263 0 3.72-1.155 3.72-2.94 0-.854-.315-1.469-1.006-1.927h2.646c.157 0 .28-.123.28-.28a.277.277 0 00-.28-.28H9.439a6.514 6.514 0 00-.608-.164L7.716 7.96c-1.387-.335-1.975-.759-1.975-1.518 0-.957.943-1.633 2.249-1.633 1.176 0 2.016.533 2.351 1.476.117.26.274.383.547.383.356 0 .574-.205.574-.547 0-.102-.013-.212-.04-.314-.308-1.245-1.675-2.099-3.432-2.099-2.058 0-3.541 1.169-3.541 2.823 0 .807.3 1.408.943 1.86H2.637a.277.277 0 00-.28.28c0 .157.123.28.28.28z","fill":"#000C1F"}})])
          )
        }
      }
    